import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const ModalPortal = ({ children }: PropsWithChildren) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  return mounted ? ReactDOM.createPortal(children, document.body) : null;
};

export default ModalPortal;
